import { z } from "zod";

/**
 * Search-param schema for the `/users` route.
 *
 * NOTE on the `userId` type: TanStack Router's default search parser
 * (`parseSearchWith(JSON.parse)`) JSON-parses every raw query value, so an
 * unquoted numeric id in the URL — e.g. `/users?userId=270`, which is exactly
 * what `ROUTES.userDetail(id)` builds — arrives here as the **number** `270`,
 * not the string `"270"`. A plain `z.string()` then rejects it with
 * `invalid_type` and the thrown error crashes the router's loader pipeline.
 * Staging/synthetic users have numeric ids (267, 268, 270…), so every link to
 * their detail view broke. We accept whatever the parser yields and coerce to a
 * string — the shape the rest of the app and the admin API client expect.
 */
export const usersSearchSchema = z.object({
  userId: z.coerce.string().optional(),
});

export type UsersRouteSearch = z.infer<typeof usersSearchSchema>;
